/* eslint-disable */
require('./back-black')
require('./back-white')
require('./back')
require('./down-black')
require('./down-dark')
require('./down-white')
require('./down')
require('./elevator-black')
require('./elevator-white')
require('./elevator')
require('./exit-black')
require('./exit-white')
require('./exit')
require('./finish')
require('./forward-black')
require('./forward-white')
require('./forward')
require('./in-black')
require('./in-white')
require('./in')
require('./left-black')
require('./left-white')
require('./left')
require('./marker-black')
require('./marker-white')
require('./marker')
require('./out-black')
require('./out-white')
require('./out')
require('./right-black')
require('./right-white')
require('./right')
require('./straight-black')
require('./straight-white')
require('./straight')
require('./up-black')
require('./up-dark')
require('./up-white')
require('./up')
require('./w-finish-black')
require('./w-finish-white')
require('./w-finish')
